import { Box, Typography } from '@mui/material';

import { needsYouBannerBody, needsYouBannerTitle } from '../copy';
import type { PayerAudience } from '../types';

/**
 * The banner above the payer table, derived from folded state: it counts
 * `needs_customer` payers and never invents a number.
 */
export function NeedsYouBanner({
  count,
  audience,
}: {
  count: number;
  audience?: PayerAudience;
}) {
  return (
    <Box
      sx={{
        backgroundColor: '#fff8ed',
        border: '1px solid #f0cfa0',
        borderLeft: '4px solid #d97706',
        borderRadius: '8px',
        px: '18px',
        py: '15px',
      }}
    >
      <Typography sx={{ fontSize: '14px', fontWeight: 700, color: '#7c3f06' }}>
        {needsYouBannerTitle(count, audience)}
      </Typography>
      <Typography sx={{ fontSize: '13px', lineHeight: 1.55, color: '#8a5a1a', mt: '3px' }}>
        {needsYouBannerBody(audience)}
      </Typography>
    </Box>
  );
}
